import { Heading, Line, TextInput, Text, BottomButton } from 'components'
import { useState } from 'react'
import { useCmowRegist } from 'api/common/cmow-fetch'
import useModal from 'hook/useModal'
import { getMessage } from 'utils/message-util'
import { userInfoState } from 'store/atom/user-state-atom'
import { useRecoilValue } from 'recoil'

export default function Cmow({ info = {}, emp = {}, ok }) {
  const userInfo = useRecoilValue(userInfoState)
  const [cn, setCn] = useState('')
  const { alertModal, confirmModal, closeModal } = useModal()
  const cmowRegist = useCmowRegist({
    successHandler: () => {
      alertModal(getMessage('common_msg_001', { status: '발송' }), () => {
        ok()
        closeModal()
      })
    },
    errorHandler: () => {},
  })

  const goSave = () => {
    if (cn.trim() === '') {
      alertModal(getMessage('common_validation_004', { target: '메시지' }))
      return
    }

    confirmModal('발송하시겠습니까?', () => {
      cmowRegist.mutate({
        ttlDvsnCd: '1',
        rmrk: JSON.stringify(info),
        cn: cn?.replace(new RegExp('\n', 'gi'), '<br />'),
        recrId: emp.userId,
        regrId: userInfo.userId,
      })
      closeModal()
    })
  }

  return (
    <>
      <section className="wrapper mt16">
        <Heading text="받을 사람" className="mb8 f-16 c-3" />
        <div className="mb24">
          {/* <Text className="f-14 c-6 mt8">{emp.userId}</Text> */}
          <Text className="f-14 c-3 mt4">{`${emp.empNm} (${emp.shpNm})`}</Text>
          <Line size="1" color="gray" className="mt12" />
        </div>

        {/* <Heading text="공유링크" className="mb8 f-16 c-3" />
        <div className="mb24">
          <Text className="f-14 c-3 mt8">본사소식 &#62; 식품위생관리책임자지정확인서(양...</Text>
          <Text className="f-14 c-3 mt4">
            <a href="#" className="link">
              http://cjwwm.cj.net/Mail/exweb/main_fra me.aspx
            </a>
          </Text>
        </div> */}

        <Heading text="메세지" className="mb8 f-16 c-3" />
        <TextInput type="textarea" value={cn} onChange={(e) => setCn(e.target.value)} />
      </section>
      <BottomButton
        refresh={false}
        data={[
          // { text: "이미지등록" },
          { title: '발송', color: 'primary' },
        ]}
        onClick={goSave}
      />
    </>
  )
}
